

















import Vue, { PropType } from 'vue';
import { Modality } from '@/store/modules/course/state';

export default Vue.extend({
  props: {
    value: {
      type: String as PropType<Modality>,
      default: 'EAD',
    },
  },
  computed: {
    options(): { value: Modality; label: string }[] {
      return [
        { value: 'EAD', label: this.$t('modality.ead') as string },
        { value: 'SEMI', label: this.$t('modality.semi') as string },
      ];
    },
  },
  methods: {
    select(modality: Modality) {
      if (modality !== this.value) this.$emit('input', modality);
    },
  },
});
